import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  CircularProgress,
} from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { Send } from "@mui/icons-material";

const statusConfig = {
  rejected: {
    icon: <ErrorOutlineIcon color="warning" fontSize="large" />,
    title: "Reject Receipt",
    message: (id) => `Are you sure you want to reject the receipt of ${id}?`,
    confirmText: "Yes, Reject",
    color: "warning",
  },
  received: {
    icon: <CheckCircleOutlineIcon color="success" fontSize="large" />,
    title: "Mark as Received",
    message: (id) => `Are you sure you want to mark ${id} as received?`,
    confirmText: "Yes, Mark Received",
    color: "success",
  },
  cancelled: {
    icon: <CancelIcon color="error" fontSize="large" />,
    title: "Cancel Receipt",
    message: (id) => `Are you sure you want to cancel the receipt of ${id}?`,
    confirmText: "Yes, Cancel",
    color: "error",
  },
};

const StatusDialog = ({
  isLoading,
  open,
  onClose,
  onConfirm,
  status,
  itemId,
}) => {
  const config = statusConfig[status];

  if (!config) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <Box sx={{ p: 2 }}>
        <DialogTitle textAlign="center">
          {config.icon}
          <Typography variant="h6" mt={1}>
            {config.title}
          </Typography>
        </DialogTitle>

        <DialogContent>
          <Typography textAlign="center">{config.message(itemId)}</Typography>
        </DialogContent>

        <DialogActions
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            pb: 2,
            gap: 2,
          }}
        >
          <Button
            disabled={isLoading}
            variant="contained"
            color={config.color}
            onClick={onConfirm}
            startIcon={
              isLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <Send />
              )
            }
          >
            {isLoading ? config.confirmText + "..." : config.confirmText}
          </Button>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

export default StatusDialog;
